import React from 'react'
import ContactSection from '../Sections/Contact/ContactForm'
import Centers from '../Sections/Contact/Centers'
function Contact() {
  return (
    <>
    <ContactSection/>
    <Centers/>
    </>
  )
}

export default Contact
